module.exports = "/assets/a3117acad0e9ee5bf968ba38054a9e49.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/KE.png
// module id = 1542
// module chunks = 0